module.exports = __webpack_public_path__ + "static/media/bed.f8b17278.svg";